module.exports = __webpack_public_path__ + "static/media/thai.8a9e9d24.svg";